import { Outlet } from "react-router-dom";
import type { RSSFeed } from "@/types/feed";
import type { RSSFeedItem } from "@/types/feedItem";
import { useState } from "react";
import { AppContext, type AppContextType } from "./contexts/AppContext";

function App() {
  const [selectedFeed, setSelectedFeed] = useState<RSSFeed | null>(null);
  const [selectedItem, setSelectedItem] = useState<RSSFeedItem | null>(null);

  // Create context value
  const contextValue: AppContextType = {
    selectedFeed,
    selectedItem,
    setSelectedFeed,
    setSelectedItem
  };

  return (
    <AppContext.Provider value={contextValue}>
      <Outlet />
    </AppContext.Provider>
  );
}

export default App;
